import * as React from "react";

import useFetchCurrentUser from "../hooks/useFetchCurrentUser";

import useSignOut from "./useSignOut";

function useUnauthorizeOnError() {
  const { isError } = useFetchCurrentUser();
  const signOut = useSignOut();

  React.useEffect(() => {
    if (isError) {
      signOut();
    }
  }, [signOut, isError]);
}

export default useUnauthorizeOnError;
